import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import SessionManager from "../../../../utils/sessionManager";
import { showAccessDeniedAlert } from "../../../../utils/accessDenied";
import { showTokenExpiredAlert } from "../../../../utils/alert";

export const tehsilList = createAsyncThunk('tehsilList', async ({ pageable: data, navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `tehsil`,
            params: {
                'pageSize': data?.pageSize,
                'pageNo': data?.currentPage,
                'search': data?.search,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const tehsilListSlice = createSlice({
    name: 'tehsilList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(tehsilList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = [];
            }

        });
        builder.addCase(tehsilList.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default tehsilListSlice.reducer; 